import { render, staticRenderFns } from "./ModalNpay.vue?vue&type=template&id=3a87fe84&scoped=true&"
import script from "./ModalNpay.vue?vue&type=script&lang=js&"
export * from "./ModalNpay.vue?vue&type=script&lang=js&"
import style0 from "./ModalNpay.vue?vue&type=style&index=0&id=3a87fe84&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a87fe84",
  null
  
)

export default component.exports